import { Button, Stack, Typography } from '@mui/material';
import { BaseDialog } from '@/components/shared/base-dialog';
import { useNotification } from '@/context/notification';
import { useResetEmployeePassword } from '@/data/employees';
import type { Employee } from '@/data/employees/interfaces';

interface ResetEmployeePasswordProps {
  employee: Employee;
  onClose: () => void;
}

export const ResetEmployeePassword = ({
  employee,
  onClose,
}: ResetEmployeePasswordProps) => {
  const { mutate: resetEmployeePassword, isPending } =
    useResetEmployeePassword();
  const { toast } = useNotification();

  const handlePasswordReset = async () => {
    resetEmployeePassword(
      { id: employee.id },
      {
        onSuccess: ({ data }) => {
          toast({
            content: data?.message || 'Senha redefinida com sucesso.',
            type: 'success',
          });
          onClose();
        },
        onError: () => {
          toast({ content: 'Erro ao alterar email', type: 'error' });
        },
      }
    );
  };

  return (
    <BaseDialog
      title="Redefinir senha"
      onClose={onClose}
      open
      actionsComponent={
        <>
          <Button onClick={onClose} variant="outlined">
            Cancelar
          </Button>
          <Button
            loading={isPending}
            onClick={handlePasswordReset}
            variant="contained"
          >
            Redefinir senha
          </Button>
        </>
      }
    >
      <Stack spacing={2}>
        <Typography>
          Ao confirmar, enviaremos um email para{' '}
          <strong>{employee?.email}</strong> definir uma nova senha.
        </Typography>
      </Stack>
    </BaseDialog>
  );
};
